import { PaymentIntentStatus } from '../../../models/payment/dto/payment-intent.dto';

/**
 * Returns the Chakra color scheme for a payment intent status in coaching context.
 * Handles special case: setup intent + pay_later → 'blue'.
 */
export function getCoachingPaymentColorScheme(
  status: PaymentIntentStatus,
  isSetupIntentPayment: boolean,
): string {
  if (isSetupIntentPayment && status === PaymentIntentStatus.pay_later) {
    return 'blue';
  }

  switch (status) {
    case PaymentIntentStatus.succeeded:
      return 'green';
    case PaymentIntentStatus.processing:
    case PaymentIntentStatus.requires_action:
    case PaymentIntentStatus.requires_confirmation:
    case PaymentIntentStatus.requires_payment_method:
      return 'yellow';
    case PaymentIntentStatus.canceled:
      return 'red';
    case PaymentIntentStatus.refunded:
    case PaymentIntentStatus.refunding:
      return 'red';
    default:
      return 'red';
  }
}

/**
 * Returns a status label key for a payment intent in coaching context.
 */
export function getCoachingPaymentLabelKey(
  status: PaymentIntentStatus,
  isSetupIntentPayment: boolean,
): 'pay_later' | 'completed' | 'pending' | 'cancelled' | 'failed' {
  if (isSetupIntentPayment && status === PaymentIntentStatus.pay_later) {
    return 'pay_later';
  }

  switch (status) {
    case PaymentIntentStatus.succeeded:
      return 'completed';
    case PaymentIntentStatus.processing:
    case PaymentIntentStatus.requires_action:
    case PaymentIntentStatus.requires_confirmation:
    case PaymentIntentStatus.requires_payment_method:
      return 'pending';
    case PaymentIntentStatus.canceled:
      return 'cancelled';
    default:
      return 'failed';
  }
}

/**
 * Formats a payment amount from cents to display string.
 */
export function formatCoachingPaymentAmount(amountInCents: number, currency: string): string {
  return `${(amountInCents / 100).toFixed(2)} ${currency.toUpperCase()}`;
}
